module.exports = __webpack_public_path__ + "img/navigationalAidsLighthouse.90112f87.svg";